import React from 'react';
import { useCommonContextProps } from '@/hooks';
import { ViewResolverComponent } from '../view-resolver';
import { getBannerHostUrl } from '../../utils/utils';
import { SalesfloorWidget } from '../salesfloor-widget';

export default function CommonComponent({
  viewDefinition,
  themeTokens,
  pageId,
  headerSection,
}: {
  viewDefinition: any;
  themeTokens: any;
  pageId: any;
  headerSection: object | null | undefined;
}) {
  const {
    commonContextProps: {
      settings: { banner },
    },
  } = useCommonContextProps();

  return (
    <div data-testid="main-page">
      <ViewResolverComponent
        headerSection={headerSection}
        pageId={pageId}
        initialData={viewDefinition}
        themeTokens={themeTokens}
        seo={{
          banner,
          appTitle: 'Loblaw Digital',
          currentUrlBase: getBannerHostUrl(),
        }}
      />
      <SalesfloorWidget />
    </div>
  );
}
